document.addEventListener("DOMContentLoaded", function() {
  var urlParams = new URLSearchParams(window.location.search);
  
  if (urlParams.get('sort_by') === 'best-selling') {
    // Seleccionar el span dentro del breadcrumb activo
    var breadcrumbSpan = document.querySelector(".template-collection .breadcrumbs a.breadcrumb-active span");
    if (breadcrumbSpan) {
      breadcrumbSpan.textContent = "Best Sellers";
    }

    // Cambiar el href del breadcrumb activo
    var breadcrumbLink = document.querySelector(".template-collection .breadcrumbs a.breadcrumb-active");
    if (breadcrumbLink) {
      breadcrumbLink.setAttribute("href", "https://lamejicana.mx/collections/all?sort_by=best-selling");
    }
  }
});